import { gql } from '@apollo/client';

export const CARD_SETUP_INTENT = gql(`mutation CardSetupIntent {
   cardSetupIntent {
    setupIntentSecret
    stripeCustomerId
  }
}`);

export const PRODUCT_PAYMENT_INTENT =
  gql(`mutation ProductPaymentIntent($data: ProductPaymentIntentInput!) {
  productPaymentIntent(data: $data) {
    paymentIntentSecret
    stripeCustomerId
    customerSessionSecret
  }
}`);
